/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TimeOfDayRequest,
    TimeOfDayRequestFromJSON,
    TimeOfDayRequestFromJSONTyped,
    TimeOfDayRequestToJSON,
} from './';

/**
 * 
 * @export
 * @interface CriteriaForBookingDateTimeRequest
 */
export interface CriteriaForBookingDateTimeRequest {
    /**
     * 
     * @type {boolean}
     * @memberof CriteriaForBookingDateTimeRequest
     */
    exclude?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof CriteriaForBookingDateTimeRequest
     */
    from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CriteriaForBookingDateTimeRequest
     */
    to?: Date;
    /**
     * 
     * @type {string}
     * @memberof CriteriaForBookingDateTimeRequest
     */
    ianaTimeZone?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof CriteriaForBookingDateTimeRequest
     */
    daysOfWeek?: Array<number> | null;
    /**
     * 
     * @type {Array<TimeOfDayRequest>}
     * @memberof CriteriaForBookingDateTimeRequest
     */
    timesOfDay?: Array<TimeOfDayRequest> | null;
}

export function CriteriaForBookingDateTimeRequestFromJSON(json: any): CriteriaForBookingDateTimeRequest {
    return CriteriaForBookingDateTimeRequestFromJSONTyped(json, false);
}

export function CriteriaForBookingDateTimeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CriteriaForBookingDateTimeRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
        'from': !exists(json, 'from') ? undefined : (new Date(json['from'])),
        'to': !exists(json, 'to') ? undefined : (new Date(json['to'])),
        'ianaTimeZone': !exists(json, 'ianaTimeZone') ? undefined : json['ianaTimeZone'],
        'daysOfWeek': !exists(json, 'daysOfWeek') ? undefined : json['daysOfWeek'],
        'timesOfDay': !exists(json, 'timesOfDay') ? undefined : (json['timesOfDay'] === null ? null : (json['timesOfDay'] as Array<any>).map(TimeOfDayRequestFromJSON)),
    };
}

export function CriteriaForBookingDateTimeRequestToJSON(value?: CriteriaForBookingDateTimeRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'exclude': value.exclude,
        'from': value.from === undefined ? undefined : (value.from.toISOString()),
        'to': value.to === undefined ? undefined : (value.to.toISOString()),
        'ianaTimeZone': value.ianaTimeZone,
        'daysOfWeek': value.daysOfWeek,
        'timesOfDay': value.timesOfDay === undefined ? undefined : (value.timesOfDay === null ? null : (value.timesOfDay as Array<any>).map(TimeOfDayRequestToJSON)),
    };
}


